// Copyright (c) 2016 Deere & Company

import '@deere/cps-it.warranty-base-styles';
import * as busyCounter from './shared/action-creators/busy-counter';
import React, {PropTypes} from 'react';
import {Router, hashHistory} from 'react-router';
import IntlProvider from './intl-provider';
import {Provider} from 'react-redux';
import {readSapStatus} from './app/action-creators/sap-status';
import {routes} from './routes';
import {syncHistoryWithStore} from 'react-router-redux';

const WarrantyProvider = ({store}) => {

    const history = syncHistoryWithStore(hashHistory, store);

    history.listen(() => store.dispatch(busyCounter.resetBusyCounter()));

    function handleRouteUpdate() {

        // handle SAP down scenario

        readSapStatus(store);

        // make sure user is at top of screen

        window.scrollTo(0, 0);

    }

    return (
        <Provider store={store}>
            <IntlProvider>
                <Router
                    history={history}
                    onUpdate={() => handleRouteUpdate()}
                    routes={routes(store.getState())}
                />
            </IntlProvider>
        </Provider>
    );

};

WarrantyProvider.displayName = 'WarrantyProvider';
WarrantyProvider.propTypes = {
    store: PropTypes.object.isRequired
};

export default WarrantyProvider;



// WEBPACK FOOTER //
// ./src/warranty-provider.js